export default __webpack_public_path__ + "media/images/images/flags/nv-ec1cfbe327602073e6e7ba3c7c9e7484.png";